export default __webpack_public_path__ + "static/media/87t.8718e73f.jpg";